import React from 'react';
import { Box, Typography, TextField, Divider } from '@mui/material';
import SelectComp from '../../../../../common/components/SelectComp/SelectComp';

type QuestionAnswer = string | string[];

interface QuestionType {
  id: string;
  field_context: string;
  text: string;
  type: 'SINGLE_SELECT' | 'MULTI_SELECT' | 'FREE_TEXT';
  options: string[];
  rationale: string;
  answer?: QuestionAnswer;
}

const Questions: React.FC<{
  item: QuestionType;
  index: number;
  value: QuestionAnswer;
  onChange: (questionId: string, value: QuestionAnswer) => void;
}> = ({ item, index, value, onChange }) => {
  const mappedType =
    item.type === 'MULTI_SELECT' ? 'checkbox' : item.type === 'SINGLE_SELECT' ? 'radio' : 'text';

  const mappedOptions = item.options?.map((opt) => ({ label: opt, value: opt })) || [];

  if (mappedType === 'text') {
    return (
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            mb: 2,
          }}
        >
          {/* Number */}
          <Box
            sx={{
              width: 20,
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 400,
                color: '#1C1C1C',
                lineHeight: '24px',
              }}
            >
              {index + 1}.
            </Typography>
          </Box>

          {/* Question */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 400,
                color: '#1C1C1C',
                lineHeight: '24px',
                wordBreak: 'break-word',
              }}
            >
              {item.text}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ pl: 0, px: 1.5 }}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            value={(value as string) || ''}
            onChange={(e) => onChange(item.id, e.target.value)}
            placeholder="Write your Response..."
          />
        </Box>

        <Divider sx={{ mt: 2 }} />
      </Box>
    );
  }

  return (
    <SelectComp
      index={index + 1}
      question={item.text}
      options={mappedOptions}
      type={mappedType as 'checkbox' | 'radio'}
      value={value}
      onChange={(val) => onChange(item.id, val)}
      columns={2}
      showDivider={true}
    />
  );
};

export default Questions;
